import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
    name: 'secondsToMinutes',
    standalone: false
})
export class SecondsToMinutesPipe implements PipeTransform {

  public transform(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = (seconds % 60).toString().padStart( 2, '0');
    return `${minutes} : ${remainingSeconds}`
  }
}
